import React from "react";
import Textbox from "../../../components/Textbox";
import CheckBox from "../../../components/Checkbox/Checkbox";

const CleanDataBaseForm = (props: any) => {
  const { values, handleChange, errors, touched } = props;
  return (
    <div>
      <div className="subtitle clearfix">
        <h2 className="title2">Clean Wizard</h2>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Textbox
            name="shop_username"
            placeholder="Enter From Shop Name"
            value={values.shop_username}
            onChange={handleChange}
            label="Enter From Shop username"
            errorMessage={touched.shop_username && errors.shop_username}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="order"
            label="Clean Order"
            onChange={handleChange}
            checked={values.order}
          />
        </div>
        <div className="col-md-3 mt-4">
          <CheckBox
            name="kitchen"
            label="Clean Kitchen Items"
            onChange={handleChange}
            checked={values.kitchen}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="order_meal_item"
            label="Clean OrderMealItems"
            onChange={handleChange}
            checked={values.order_meal_item}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="diningtable"
            label="Clean Tables"
            onChange={handleChange}
            checked={values.diningtable}
          />
        </div>
      </div>
      {/* second row */}
      <div className="row">
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="food_category"
            label="Clean Category"
            onChange={handleChange}
            checked={values.food_category}
          />
        </div>
        <div className="col-md-3 mt-4">
          <CheckBox
            name="fooditem"
            label="Clean Food Item"
            onChange={handleChange}
            checked={values.fooditem}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="food_item_addons"
            label="Clean Food Item Adon"
            onChange={handleChange}
            checked={values.food_item_addons}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="food_inventory"
            label="Clean Food Inventory"
            onChange={handleChange}
            checked={values.food_inventory}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="expense"
            label="Clean Expense"
            onChange={handleChange}
            checked={values.expense}
          />
        </div>
        <div className="col-md-3 mt-4">
          <CheckBox
            name="expense_category"
            label="Clean Expense Category"
            onChange={handleChange}
            checked={values.expense_category}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="inventory"
            label="Clean Inventory"
            onChange={handleChange}
            checked={values.inventory}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="inventory_category"
            label="Clean Inventory Category"
            onChange={handleChange}
            checked={values.inventory_category}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="food_variant"
            label="Clean Food Variant"
            onChange={handleChange}
            checked={values.food_variant}
          />
        </div>
        <div className="col-md-3 mt-4">
          <CheckBox
            name="customer"
            label="Clean Customer"
            onChange={handleChange}
            checked={values.customer}
          />
        </div>
        <div className="col-md-3 mt-4 pl-4">
          <CheckBox
            name="waiting_list"
            label="Clean Waiting List"
            onChange={handleChange}
            checked={values.waiting_list}
          />
        </div>
      </div>
    </div>
  );
};

export default CleanDataBaseForm;
